import { updateDoc, doc, serverTimestamp } from 'firebase/firestore';
import { db } from '../../config';
import { fileExportStatus } from '../../../../constants/enum';

/**
 * ファイル出力履歴を削除（論理削除）
 */
export const deleteFileExportHistory = async (id: string): Promise<void> => {
  const fileExportHistoryDocRef = doc(db, 'fileExportHistory', id);
  await updateDoc(fileExportHistoryDocRef, {
    status: fileExportStatus.deleted,
    updated_at: serverTimestamp(),
  });
};
